// extracted by mini-css-extract-plugin
export default {"logoWrapper":"payout-provider-logo_logoWrapper__HJyVy"};